<script setup>
// Google Ads > Otomasyonlar
//
// DURUSTLUK NOTU: Google Ads'te "otomatik kurallar" ve "komut dosyalari"
// yalnizca Google arayuzunden yonetiliyor, API'den OKUNAMIYOR. Bu ekranda
// uydurma bir liste gostermek yerine API'nin gercekten verdigi iki
// otomasyon yuzeyini gosteriyoruz:
//   * teklif stratejileri - teklifi otomatik ayarlayan kurallar
//   * deneyler (experiments) - A/B testleri
// Okunamayan kisim icin de kullaniciyi Google arayuzune yonlendiriyoruz.
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import GoogleAdsKabuk from './GoogleAdsKabuk.vue';
import GoogleAdsTablo from './GoogleAdsTablo.vue';
import { getir, hataMetni } from './kopru.js';

const { t } = useI18n();
const route = useRoute();

const stratejiler = ref([]);
const deneyler = ref([]);
const yukleniyor = ref(false);
const hata = ref('');

const STRATEJI_SUTUN = [
  { alan: 'ad', anahtar: 'GOOGLE_ADS.SUTUN.AD', vurgu: true, siralanabilir: true },
  { alan: 'tur', anahtar: 'GOOGLE_ADS.SUTUN.TUR', tur: 'etiket' },
  { alan: 'durum', anahtar: 'GOOGLE_ADS.SUTUN.DURUM', tur: 'durum' },
  {
    alan: 'kampanya_sayisi',
    anahtar: 'GOOGLE_ADS.SUTUN.KAMPANYA_SAYISI',
    tur: 'sayi',
    siralanabilir: true,
  },
];

const DENEY_SUTUN = [
  { alan: 'ad', anahtar: 'GOOGLE_ADS.SUTUN.AD', vurgu: true, siralanabilir: true },
  { alan: 'tur', anahtar: 'GOOGLE_ADS.SUTUN.TUR', tur: 'etiket' },
  { alan: 'durum', anahtar: 'GOOGLE_ADS.SUTUN.DURUM', tur: 'durum' },
  { alan: 'baslangic', anahtar: 'GOOGLE_ADS.SUTUN.BASLANGIC' },
  { alan: 'bitis', anahtar: 'GOOGLE_ADS.SUTUN.BITIS' },
];

const yukle = async () => {
  yukleniyor.value = true;
  hata.value = '';
  try {
    const veri = await getir(route.params.accountId, 'otomasyonlar');
    stratejiler.value = veri.stratejiler || [];
    deneyler.value = veri.deneyler || [];
  } catch (e) {
    stratejiler.value = [];
    deneyler.value = [];
    hata.value = hataMetni(e, t('GOOGLE_ADS.HATA'));
  } finally {
    yukleniyor.value = false;
  }
};
</script>

<template>
  <GoogleAdsKabuk
    :baslik="t('GOOGLE_ADS.OTOMASYONLAR')"
    :aralik-goster="false"
    @aralik="yukle"
  >
    <div class="flex flex-col gap-5">
      <p v-if="hata" class="text-sm text-n-ruby-11">{{ hata }}</p>

      <div v-if="yukleniyor" class="flex justify-center p-10">
        <Spinner class="text-n-brand" />
      </div>

      <template v-else>
        <section class="flex flex-col gap-2">
          <h2 class="text-sm font-medium text-n-slate-12">
            {{ t('GOOGLE_ADS.TEKLIF_STRATEJILERI') }}
          </h2>
          <p class="text-xs text-n-slate-11">
            {{ t('GOOGLE_ADS.TEKLIF_ACIKLAMA') }}
          </p>
          <GoogleAdsTablo :sutunlar="STRATEJI_SUTUN" :satirlar="stratejiler" />
        </section>

        <section class="flex flex-col gap-2">
          <h2 class="text-sm font-medium text-n-slate-12">
            {{ t('GOOGLE_ADS.DENEYLER') }}
          </h2>
          <GoogleAdsTablo :sutunlar="DENEY_SUTUN" :satirlar="deneyler" />
        </section>

        <p
          class="px-3 py-2 text-xs rounded-lg bg-n-alpha-1 text-n-slate-11"
        >
          {{ t('GOOGLE_ADS.KURAL_NOTU') }}
        </p>
      </template>
    </div>
  </GoogleAdsKabuk>
</template>
